<template>
    <GmapMap
            :center="center"
            :zoom="15"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
            :options="{
       zoomControl: true,
       mapTypeControl: false,
       scaleControl: false,
       streetViewControl: false,
       rotateControl: false,
       fullscreenControl: false,
       disableDefaultUi: false,
       styles: [
                {
                  featureType: 'administrative',
                  elementType: 'geometry',
                  stylers: [
                            {
                              visibility: 'off'
                            }
                  ]
                },
                {
                   'featureType': 'poi',
                   'stylers': [
                            {
                              visibility: 'off'
                            }
                    ]
                },
                {
                   'featureType': 'transit',
                   'stylers': [
                            {
                              visibility: 'off'
                            }
                    ]
                }
      ]
     }"
            @click="clickOnMap"
    >
        <GmapMarker
                v-if="allowLoadLocation"
                :position="{lat:currentLocation.lat, lng:currentLocation.lng}"
                :icon="currentMarkerOptions"
        />

        <GmapMarker
                :key="index"
                v-for="(m, index) in locations(true)"
                :position="{lat:m.lat, lng:m.lng}"
                :icon="markerOptions"
                @click="toggleInfoWindow(m)"
        />

        <GmapInfoWindow
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen=false"
        >
            <div id="card">
                <div class="card-image">
                </div>
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <h5>{{displayedLocation.name}}</h5>
                        </div>
                    </div>
                    <div class="content" style="text-align: left; margin-top: 5px; margin-right: 2px">

                        <div style="display: inline-block; max-width: 90%">
                            <a :href="'tel:' + displayedLocation.tel">{{displayedLocation.tel}}</a>
                        </div>
                        <div style="display: inline-block; float: right; margin-bottom: 10px">
                            <b-button variant="outline-dark" :href="displayedLocation.google_map">
                                <img :src="require(`@/assets/map.png`)" width="30px" style="display: inline-block">
                            </b-button>
                        </div>

                        <div style="margin-bottom: 10px; margin-top: 10px">
                            เงื่อนไข: <p>{{displayedLocation.condition}}</p>
                        </div>

                        <div style="margin-bottom: 10px">
                            <p style="color: red"> ค่าใช้จ่ายหากไม่เข้าเกณฑ์: {{displayedLocation.expend}} </p>
                        </div>
                        <div style="margin-bottom: 10px">
                            ระยะเวลาทราบผล: {{displayedLocation.period}}
                        </div>
                    </div>
                </div>
            </div>

        </GmapInfoWindow>
    </GmapMap>
</template>

<script>
    import { mapGetters, mapState } from 'vuex'

    export default {
        name: "GMap",
        data() {
            return {
                currentLocation : {lat:13.7651513, lng:100.5340121},
                center: {lat:13.7651513, lng:100.5340121},
                allowLoadLocation: false,
                markerOptions: {
                    url: require(`@/assets/hospital.png`),
                    scaledSize: {width: 35, height: 35, f: 'px', b: 'px',},
                },
                currentMarkerOptions: {
                    url: require(`@/assets/you-are-here.png`),
                    scaledSize: {width: 35, height: 35, f: 'px', b: 'px',},
                },
                infoWindowPos: {
                    lat: 0,
                    lng: 0
                },
                infoWinOpen: false,
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -45
                    },
                    maxWidth: 300
                },
                infoContent: '',
                currentMidx: '',
                displayedLocation: {}
            };
        },
        computed: {
            ...mapState({
                locations: state => state.locations,
            }),
            ...mapGetters( {
                locations: 'getDisplayableLocation'
            })
        },
        methods: {
            clickOnMap: function() {
                if(this.$parent.isListDisplayed()) this.$parent.toggleList(false);
                else this.closeInfoWindow()

            },
            navigateToCurrentLocation: function() {
                if(!this.allowLoadLocation) {
                    alert('Please Allow Location Services')
                }
                else {
                    this.center = this.currentLocation
                }
            },
            navigateToLocation: function(location) {
                this.center = { lat: location.lat, lng: location.lng }
                this.toggleInfoWindow(location)
            },
            geolocation : function() {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.allowLoadLocation = true
                    this.currentLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    this.center = this.currentLocation

                });
            },
            findNesrest: function () {
                function calDistance(currentLocation, lat, lng) {
                    return Math.pow(Math.pow(currentLocation.lat - lat, 2) + Math.pow(currentLocation.lng - lng, 2), 0.5)
                }
                if(!this.allowLoadLocation) {
                    alert('Please Allow Location Services')
                }
                else {
                    const distances = this.locations(true).map(x => {
                        return {id: x.id, distance: calDistance(this.currentLocation, x.lat, x.lng)}
                    }).sort((a, b) => {
                        return a.distance - b.distance
                    })
                    console.log(distances)

                    const nearestLocation = this.locations(true).find( x => x.id == distances[0].id)
                    this.center = { lat: nearestLocation.lat, lng: nearestLocation.lng }
                    this.toggleInfoWindow(nearestLocation)
                    console.log(nearestLocation)
                }
            },
            closeInfoWindow: function() {
                if (this.infoWinOpen) this.infoWinOpen = false;
            },
            toggleInfoWindow: function (location) {
                this.displayedLocation = location
                this.infoWindowPos = {lat:location.lat, lng:location.lng};
                this.infoContent = this.getInfoWindowContent(location);


                if (this.currentMidx == location.name) {
                    this.infoWinOpen = !this.infoWinOpen;
                }

                else {
                    this.infoWinOpen = true;
                    this.currentMidx = location.name;
                }
            },

            getInfoWindowContent: function (location) {
                return (``);
            },
        },
        mounted : function() {
            this.$nextTick(function () {
                this.geolocation();
            })
        }
    }


</script>

<style scoped>

</style>
